import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import Video from "@/components/editor/primitives/video/video-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import { MAX_WIDTHS } from "@/components/editor/shared/media/constants";
import VideoWithTitleSettings, {
  VIDEO_AREA_SIZE_LARGE_TYPE,
  VIDEO_AREA_SIZE_MEDIUM_TYPE,
  VIDEO_AREA_SIZE_SMALL_TYPE,
} from "@/components/editor/shared/media/video-with-title-settings";

import { PaddingContainer, Wrapper } from "./video-with-title-component-styles";

export type VideoWithTitleBlockProps = {
  videoAreaSize?:
    | typeof VIDEO_AREA_SIZE_SMALL_TYPE
    | typeof VIDEO_AREA_SIZE_MEDIUM_TYPE
    | typeof VIDEO_AREA_SIZE_LARGE_TYPE;
};

export default function VideoWithTitle({
  videoAreaSize = VIDEO_AREA_SIZE_SMALL_TYPE,
}: VideoWithTitleBlockProps) {
  const {
    id,
    connectors: { connect },
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={id}>
      <PaddingContainer>
        <BlockMaxWidthWrapper maxWidth={rem(MAX_WIDTHS[videoAreaSize])}>
          {videoAreaSize === VIDEO_AREA_SIZE_SMALL_TYPE && (
            <Wrapper>
              <Element
                id="title"
                is={Text}
                text="Join our first digital conference"
                pattern="headingTwo"
              />
            </Wrapper>
          )}
          <Element id="video" is={Video} url="https://youtu.be/9m4oFnBLTos" />
        </BlockMaxWidthWrapper>
      </PaddingContainer>
    </BlockBackgroundColorWrapper>
  );
}

VideoWithTitle.craft = {
  custom: {
    displayName: "Video with title",
  },
  related: {
    settings: VideoWithTitleSettings,
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
